import { render, staticRenderFns } from "./CategoryTypeInput.vue?vue&type=template&id=db12fbfa&scoped=true&"
import script from "./CategoryTypeInput.vue?vue&type=script&lang=ts&"
export * from "./CategoryTypeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db12fbfa",
  null
  
)

export default component.exports